import { ChangeEvent, useEffect, useState } from "react";
import { createPortal } from "react-dom";
import { Card, Table, TextField } from "@radix-ui/themes";

function AnimationDictionaryComponent({ setDictionary, setName, animations, portalRef }) {
  const [chosenDictionary, setChosenDictionary] = useState<string>("");
  const [localDictionary, setLocalDictionary] = useState<string>("");
  const [localName, setLocalName] = useState<string>("");

  const getTargetDictionaries = (): string[] => {
    if (!localDictionary) {
      return [];
    }

    return Object.keys(animations)
      .filter((targetName) => {
        return targetName && targetName.toLowerCase().includes(localDictionary.toLowerCase());
      })
      .slice(0, 100);
  };

  const getTargetDictionary = () =>
    chosenDictionary in animations ? animations[chosenDictionary] : null;

  const getTargetNames = (): string[] => {
    const targetDictionary = getTargetDictionary();

    if (targetDictionary === null) {
      return [];
    }

    return targetDictionary.filter((targetName: string) =>
      targetName.toLowerCase().includes(localName?.toLowerCase()),
    );
  };

  const setAnimation = (dictionary: string, name: string): void => {
    setDictionary(dictionary);
    setName(name);
  };

  const targetDictionaries = getTargetDictionaries();

  return createPortal(
    <Card className="absolute bottom-10 left-10 p-5 w-[28rem]" variant="solid-surface-gradient">
      <div className="grid grid-cols-12 gap-3">
        <div className="col-span-6 ">
          <div className="h-[25rem] overflow-y-scroll">
            <Table.Root>
              <Table.Body>
                {targetDictionaries.map((keyName) => {
                  return (
                    <Table.Row key={keyName}>
                      <Table.ColumnHeaderCell onClick={() => setChosenDictionary(keyName)}>
                        <div className={keyName === chosenDictionary ? "text-amber-400" : ""}>
                          {keyName}
                        </div>
                      </Table.ColumnHeaderCell>
                    </Table.Row>
                  );
                })}
              </Table.Body>
            </Table.Root>
          </div>
        </div>
        <div className="col-span-6">
          <div className="h-[25rem] overflow-y-scroll">
            <Table.Root>
              <Table.Body>
                {getTargetNames().map((keyName) => {
                  return (
                    <Table.Row key={keyName}>
                      <Table.ColumnHeaderCell
                        onClick={() => setAnimation(chosenDictionary, keyName)}
                      >
                        {keyName}
                      </Table.ColumnHeaderCell>
                    </Table.Row>
                  );
                })}
              </Table.Body>
            </Table.Root>
          </div>
        </div>

        <div className="col-span-6">
          <div className="mb-2">
            <div className="mb-1">Dictionary</div>
            <TextField.Root
              size="3"
              name="composedName"
              onChange={(e) => setLocalDictionary(e.target.value)}
              value={localDictionary}
              required
              placeholder="dictionary"
            />
          </div>
        </div>

        <div className="col-span-6">
          <div className="mb-2">
            <div className="mb-1">Name</div>
            <TextField.Root
              size="3"
              name="composedName"
              onChange={(e) => setLocalName(e.target.value)}
              value={localName}
              required
              placeholder="name"
            />
          </div>
        </div>

        <div className="col-span-12 text-center">
          <div>Загружено {animations ? Object.keys(animations).length : 0} шт.</div>
          <div>Найдено {targetDictionaries.length} шт.</div>
        </div>
      </div>
    </Card>,
    portalRef.current,
  );
}

export default AnimationDictionaryComponent;
